document.addEventListener('DOMContentLoaded', () => {

    const elementoModalVerVideo = document.getElementById('modal-ver-video');

    const iframeVideoAnaliseCurriculo = document.getElementById('video-analise-curriculo');
    const iframeVideoSimuladorEntrevista = document.getElementById('video-simulador-entrevista');

    const modalIframeVerDemoProdutos = new bootstrap.Modal(elementoModalVerVideo, {
        backdrop: 'static',
        keyboard: false
    });

    // os iframes nascem sem src (d-none nao impede o fetch): o player do YouTube so e baixado quando o modal abre
    elementoModalVerVideo.addEventListener('show.bs.modal', () => {
        [iframeVideoAnaliseCurriculo, iframeVideoSimuladorEntrevista]
            .filter(iframe => !iframe.classList.contains('d-none') && iframe.getAttribute('src') !== iframe.dataset.src)
            .forEach(iframe => iframe.setAttribute('src', iframe.dataset.src));
    });

    elementoModalVerVideo.addEventListener('hidden.bs.modal', () => {
        // about:blank pausa e ainda descarta o player. É a forma mais eficaz sem a API do YouTube.
        iframeVideoAnaliseCurriculo.setAttribute('src', 'about:blank');
        iframeVideoSimuladorEntrevista.setAttribute('src', 'about:blank');
    });

    const btnVerDemoAnaliseCurriculo = document.querySelector('.btn-ver-demo-analise-curriculo');

    if (btnVerDemoAnaliseCurriculo) {
        btnVerDemoAnaliseCurriculo.addEventListener('click', (e) => {
            e.preventDefault();
            iframeVideoAnaliseCurriculo.classList.remove('d-none');
            iframeVideoSimuladorEntrevista.classList.add('d-none');
            modalIframeVerDemoProdutos.show();
        });
    }

    const btnVerDemoSimuladorEntrevista = document.querySelector('.btn-ver-demo-simulador-entrevista');

    if (btnVerDemoSimuladorEntrevista) {
        btnVerDemoSimuladorEntrevista.addEventListener('click', (e) => {
            e.preventDefault();
            iframeVideoAnaliseCurriculo.classList.add('d-none');
            iframeVideoSimuladorEntrevista.classList.remove('d-none');
            modalIframeVerDemoProdutos.show();
        });
    }

    // Animação de revelação ao rolar a página
    const movimentoReduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sectionsToAnimate = document.querySelectorAll('.fade-in-section');

    // .fade-in-section nasce com opacity:0; sem observer (movimento reduzido ou browser
    // sem IntersectionObserver) a pagina inteira abaixo do hero ficaria em branco.
    if (movimentoReduzido || !('IntersectionObserver' in window)) {
        sectionsToAnimate.forEach(section => section.classList.add('visible'));
    } else {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1 // Ativa quando 10% do elemento está visível
        });

        sectionsToAnimate.forEach(section => {
            observer.observe(section);
        });
    }

    // Animação de fundo "Matrix" para toda a página.
    // Nenhuma media query alcanca canvas: o opt-out de movimento reduzido tem que ser aqui,
    // senao sao 30 repinturas da viewport por segundo, para sempre, para quem pediu o contrario.
    const canvas = movimentoReduzido ? null : document.getElementById('hero-canvas');
    if (canvas) {
        const ctx = canvas.getContext('2d');

        let width, height;
        const fontSize = 16;
        let columns;
        let drops = [];

        const resizeCanvas = () => {
            width = canvas.width = window.innerWidth;
            height = canvas.height = window.innerHeight; // Ajustado para 100% da viewport
            columns = Math.floor(width / fontSize);
            drops = [];
            for (let i = 0; i < columns; i++) {
                drops[i] = 1;
            }
        }

        const characters = "#%-+="; // Caracteres atualizados
        const charArray = characters.split('');

        const draw = () => {
            // Fundo semi-transparente para criar o efeito de rastro
            ctx.fillStyle = 'rgba(12, 10, 9, 0.05)';
            ctx.fillRect(0, 0, width, height);

            ctx.fillStyle = 'hsl(217, 91%, 60%)'; // Cor dos caracteres
            ctx.font = `${fontSize}px monospace`;

            for (let i = 0; i < drops.length; i++) {
                const text = charArray[Math.floor(Math.random() * charArray.length)];
                ctx.fillText(text, i * fontSize, drops[i] * fontSize);

                if (drops[i] * fontSize > height && Math.random() > 0.975) {
                    drops[i] = 0;
                }
                drops[i]++;
            }
        }

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(resizeCanvas, 250);
        });

        resizeCanvas();
        setInterval(draw, 33); // Controla a velocidade da animação
    }
});

